import { CompleteStylistFragment } from 'drycut-graphql';
import { Stack } from 'ui-components';
import PickupTime from './PickupTime';
import ServiceTime from './ServiceTime';
import TimeDisplay from './TimeDisplay';

type Props = {
  stylist: CompleteStylistFragment;
};

export function CuttingTime({ stylist }: Props) {
  const { currentServiceExecution: service } = stylist;

  const isIdle = !(service?.startedAt || service?.calledAt);

  return (
    <Stack>
      {isIdle && <TimeDisplay title="No customer" />}
      {service?.calledAt && !service?.startedAt && <PickupTime calledAt={service.calledAt} />}
      {service?.startedAt && <ServiceTime startedAt={service.startedAt} />}
    </Stack>
  );
}
